module.exports = __webpack_public_path__ + "img/img4.0cd123c1.svg";